import $ from "jquery";

import utils from "../helpers/utils";

// The message we show to the user if they were redirected to the page
// because a page they were trying to access doesn't allow their role + region
// this can happen especially when someone shares a link to a page that has restrictions

function init(): void {
  const $message = $(".js-content-not-available-message");
  if ($message.length) {
    const urlParams = utils.getUrlParameters();
    const showMessageParam = urlParams.get("contentNotAvailable");
    if (!!showMessageParam && showMessageParam === "true") {
      const $close = $(".js-content-not-available-message-close");
      $message.removeClass("hide");
      // Delete the parameter. Keep all other parameters. Hide the alert.
      $close.on("click", () => {
        $message.addClass("hide");
        urlParams.delete("contentNotAvailable");
        const newParams = urlParams.toString();
        window.history.pushState(newParams, "", "?" + newParams);
      });
    }
  }
}

export default { init };
